import { Customer as CustomerTable } from "@/components/CustomersFacilitiesTable"
import { Customer } from "@/types/customer"

export const formatCustomers = (customers: Customer[]) => {
   const formattedCustomers: CustomerTable[] = customers.map((customerItem) => {
      const cells = customerItem.facilities.reduce(
         (acc, facility) => acc + (facility.cells ? facility.cells : 0),
         0
      )
      const wearables = customerItem.facilities.reduce(
         (acc, facility) => acc + (facility.wearables ? facility.wearables : 0),
         0
      )
      const users = customerItem.facilities.reduce(
         (acc, facility) => acc + (facility.users ? facility.users : 0),
         0
      )
      const formattedCustomerItem: CustomerTable = {
         cells,
         wearables,
         users,
         customerName: customerItem.name,
         ...customerItem,
      }
      return { ...formattedCustomerItem }
   })
   return formattedCustomers
}
